import { render, staticRenderFns } from "./_Basic.vue?vue&type=template&id=9d2d56d2&scoped=true&"
import script from "./_Basic.vue?vue&type=script&lang=js&"
export * from "./_Basic.vue?vue&type=script&lang=js&"
import style0 from "./_Basic.vue?vue&type=style&index=0&id=9d2d56d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2d56d2",
  null
  
)

export default component.exports